import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AxiosResponse } from "axios";
import configs from "config";
import { PayInRO } from "interfaces/pay.interface";
import { wrapBaseApi } from "utils/apiWrapper";
import ls from "utils/secureStorage";

interface PayInDto {
  classId: string;
  // forWho: string;
  txId: string;
}

interface IMarkAsPaid {
  paymentId: string;
  paymentUrl: string;
}
interface IPaymentMethod {
  paymentId: string;
  paymentMethod: string;
}
export const payApi = createApi({
  reducerPath: "pay",
  refetchOnMountOrArgChange: true,
  tagTypes: ['payment-method'],
  baseQuery: fetchBaseQuery({
    baseUrl: configs.WALLET_BASE_URL,
    prepareHeaders: (headers, _) => {
      const accessKey = ls.get(configs.ACCESS_KEY);

      const _auth = ls.get(configs.AUTH_TOKEN_KEY);
      const auth = _auth ? JSON.parse(_auth) : undefined;

      let authTokenAndAccessKey = [];
      if (auth?.token) authTokenAndAccessKey.push(auth?.token);
      if (accessKey) authTokenAndAccessKey.push(accessKey);

      if (authTokenAndAccessKey) headers.set("Authorization", authTokenAndAccessKey.join("::,"));
      headers.set("Content-Type", "application/json");
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      return headers;
    },
  }),

  endpoints: (builder) => ({
    payIn: builder.query({
      query: ({ classId, txId }: PayInDto) => wrapBaseApi(`/wallet/widget/pay-in?class=${classId}&for=${'cico'}&txId=${txId}`),
      transformResponse: (res: AxiosResponse<PayInRO>) => res?.data
    }),

    getPayById: builder.query({
      query: (paymentId: string) => wrapBaseApi(`/wallet/widget/pay-status/${paymentId}`),
      transformResponse: (res: AxiosResponse<PayInRO>) => res?.data
    }),

    markPaymentAsPaid: builder.mutation({
      query: ({ paymentId, paymentUrl }: IMarkAsPaid) => ({
        url: wrapBaseApi(`/wallet/widget/payments/${paymentId}/paid`),
        body: {
          paymentUrl
        },
        method: 'POST'
      }),

      transformResponse: (res: AxiosResponse) => res.data
    }),

    changePaymentMethod: builder.mutation({
      query: ({ paymentId, paymentMethod }: IPaymentMethod) => ({
        url: wrapBaseApi(`/wallet/widget/pay-in/${paymentId}/method?paymentMethod=${paymentMethod}`),
        body: {
          paymentMethod
        },
        method: 'PATCH'
      }),

      transformResponse: (res: AxiosResponse) => res.data,
      invalidatesTags: ['payment-method']
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  usePayInQuery,
  useMarkPaymentAsPaidMutation,
  useChangePaymentMethodMutation,
  useGetPayByIdQuery,
} = payApi;

export default payApi;
